import React from "react";
import Sidebar from "../components/Sidebar";

interface MainLayoutProps {
  children: React.ReactNode;
  userRole: any;
}

const MainLayout: React.FC<MainLayoutProps> = ({ children, userRole }) => (
  <div>
    {/*<Header />*/}
    <div className="h-screen bg-gray-50 px-20 pt-[120px]">
      <div className="flex main-layout-design">
        <div className="left-side">
          <Sidebar userRole={userRole} />
        </div>
        <main className="right-side">{children}</main>
      </div>
      {/*<Footer />*/}
    </div>
  </div>
);

export default MainLayout;
